import { CommonModule } from "@angular/common";
import {
  Component,
  DOCUMENT,
  EventEmitter,
  Input,
  Output,
  inject,
} from "@angular/core";
import { PaymentResponsePixData } from "@models/payment";
import { SnackBarService } from "@services/snack-bar.service";
import { QrCodeModule } from "ng-qrcode";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";

@Component({
  selector: "app-seller-pix-checkout",
  imports: [CommonModule, QrCodeModule, ButtonComponent],
  templateUrl: "./seller-pix-checkout.component.html",
  styleUrl: "./seller-pix-checkout.component.scss",
})
export class SellerPixCheckoutComponent {
  private readonly snackbarService = inject(SnackBarService);
  private readonly document = inject(DOCUMENT);

  @Input() pixData: PaymentResponsePixData | null = null;
  @Input() loading = false;
  @Input() statusPaymentPix = "";
  @Input() isWebSocketConnected = false;
  /** Oculta QR e cópia quando a cobrança é exibida no modal. */
  @Input() detailsSuppressed = false;
  @Input() showInternationalHint = false;
  @Input() canGenerateQr = true;
  @Output() generateChargeClick = new EventEmitter<void>();

  copyPixKey(): void {
    if (!this.pixData?.qr_code) {
      this.snackbarService.openSnackBar("Erro ao copiar pix!", "Fechar", "error");
      return;
    }

    const input = this.document.createElement("input");
    input.style.position = "fixed";
    input.style.opacity = "0";
    input.value = this.pixData.qr_code;
    this.document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    this.document.execCommand("copy");
    this.document.body.removeChild(input);

    this.snackbarService.openSnackBar(
      "Pix copia e cola copiado com sucesso!",
      "Fechar",
      "success",
    );
  }
}
